// extracted by mini-css-extract-plugin
module.exports = {"container":"founder_container__KlF6I","logo":"founder_logo__tRZ_7","text":"founder_text__VtKSn"};